'use strict';

const react = require('@emotion/react');
const React = require('react');
const components_navigation_PageNavigation_PageNavigationContext = require('./PageNavigationContext.cjs.js');
const theme_Colors = require('../../../theme/Colors.cjs.js');
require('../../../theme/Shadows.cjs.js');
require('../../../theme/Typography.cjs.js');
const components_display_Icon_Icon = require('../../display/Icon/Icon.cjs.js');
const components_display_Text_Text = require('../../display/Text/Text.cjs.js');
const components_display_TooltipWrapper_TooltipWrapper = require('../../display/TooltipWrapper/TooltipWrapper.cjs.js');
const components_layout_Spacer_Spacer = require('../../layout/Spacer/Spacer.cjs.js');
const components_navigation_PageNavigation_NestedSecondRow = require('./NestedSecondRow.cjs.js');
const components_navigation_PageNavigation_PageNavigationBadge = require('./PageNavigationBadge.cjs.js');
const components_navigation_PageNavigation_PageNavigationRow = require('./PageNavigationRow.cjs.js');
const components_navigation_PageNavigation_utils_checkIsTruncated = require('./utils/checkIsTruncated.cjs.js');
const styleMixins_reset = require('../../../style-mixins/reset.cjs.js');

const Styles = {
  list: react.css`
    ${styleMixins_reset.boxSizing};
    list-style: none;
    margin: 0;
    padding: 0;
  `,
  textEllipsis: (textColor) => react.css`
    color: ${theme_Colors.Colors[textColor]};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  `,
  // The width value for textWrap is 90% of the row width, less the width
  // of the space available for the Badge count (32px)
  textWrap: react.css`
    align-items: center;
    display: flex;
    flex-direction: row;
    width: calc(90% - var(--zds-size-32));
  `,
  rowContainer: react.css`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: var(--zds-space-8) var(--zds-space-24) var(--zds-space-8)
      var(--zds-space-8);
    position: relative;
  `,
  iconContainer: [
    react.css`
      display: inline-block;
      left: 0px;
      padding: var(--zds-space-8);
      position: absolute;
      &:focus-visible {
        outline-color: ${theme_Colors.Colors.UiPrimaryStrongest};
      }
    `
  ],
  iconTextSpacing: react.css`
    padding-left: var(--zds-space-20);
  `
};
function NestedFirstRow({ isExpanded, item, onSelect }) {
  const { toggleExpand } = React.useContext(components_navigation_PageNavigation_PageNavigationContext);
  const [isTruncated, setIsTruncated] = React.useState(false);
  const textRef = React.useRef(null);
  const nestedListRef = React.useRef(null);
  React.useEffect(() => {
    if (nestedListRef.current) {
      if (isExpanded) {
        nestedListRef.current.removeAttribute("hidden");
      } else {
        nestedListRef.current.setAttribute("hidden", "until-found");
      }
    }
  }, [isExpanded]);
  React.useEffect(() => {
    setIsTruncated(components_navigation_PageNavigation_utils_checkIsTruncated(textRef));
  }, []);
  const onToggleSelect = () => {
    toggleExpand(item.id);
    return onSelect;
  };
  const InnerContent = ({ hover, selected }) => {
    const textColor = hover || selected ? "UiPrimaryStrongest" : "GrayWarm10";
    return react.jsx(
      "div",
      { css: Styles.rowContainer, "data-testid": "pagenavigation-nestedfirstrow", "data-zds": true },
      react.jsx(
        "span",
        { css: Styles.textWrap },
        item.children ? react.jsx(
          "div",
          { css: Styles.iconContainer, "data-testid": "pagenavigation-nestedfirstrow-icon", "data-zds": true },
          react.jsx(components_display_Icon_Icon.Icon, { color: "GrayWarm6", name: isExpanded ? "arrowSmallUp" : "arrowSmallDown", size: 20 })
        ) : react.jsx(components_layout_Spacer_Spacer.Spacer, { width: 20 }),
        react.jsx(
          "span",
          { css: [
            Styles.textEllipsis(textColor),
            item.children && Styles.iconTextSpacing
          ], "data-testid": "pagenavigation-nestedfirstrow-text", ref: textRef, "data-zds": true },
          react.jsx(components_display_Text_Text.Text, { color: textColor, margin: "0 0 0 8px", type: "Body3" }, item.title)
        )
      ),
      item.count && react.jsx(components_navigation_PageNavigation_PageNavigationBadge, { variant: "neutral" }, item.count.toString())
    );
  };
  const Content = ({ hover, selected }) => isTruncated ? react.jsx(components_display_TooltipWrapper_TooltipWrapper.TooltipWrapper, { allowMultilineTooltip: true, content: item.title, isBlock: true, position: "northeast" }, () => react.jsx(InnerContent, { hover, selected })) : react.jsx(InnerContent, { hover, selected });
  const NestedList = React.useMemo(() => item.children ? () => {
    var _a;
    return react.jsx("ul", { css: Styles.list, "data-zds": true, hidden: !isExpanded, ref: nestedListRef }, (_a = item.children) === null || _a === void 0 ? void 0 : _a.map((i) => react.jsx(components_navigation_PageNavigation_NestedSecondRow, { item: i, key: i.id, onSelect })));
  } : void 0, [item, isExpanded, onSelect]);
  return react.jsx(components_navigation_PageNavigation_PageNavigationRow, { content: Content, isSelectable: false, item, nestedList: NestedList, onSelect: item.children ? onToggleSelect : onSelect });
}

module.exports = NestedFirstRow;
//# sourceMappingURL=NestedFirstRow.cjs.js.map
